var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('pageMarkersTitle')))]),_c('p',[_vm._v(_vm._s(_vm.$t('pageMapsText')))]),_c('RecentItems',{attrs:{"itemType":"markers"}}),_c('MarkerTable',{attrs:{"getData":_vm.getData,"getIds":_vm.getIds}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }